import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';

// project imports
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';
import VrpRoutes from './VrpRoutes';
import IberdrolaRoutes from './IberdrolaRoutes';
import AreasRoutes from './AreasRoutes';
import AreasIberdrolaRoutes from './AreasIberdrolaRoutes';
import ContabilidadRoutes from './ContabilidadRoutes';
import ProduccionRoutes from './ProduccionRoutes';
import OperariosRoutes from './OperariosRoutes';
import CuadrosRoutes from './CuadrosRoutes';
import FamiliasRoutes from './FamiliasRoutes';
import NotificationsRoutes from './NotificationsRoutes';
import AdminRoutes from './AdminRoutes';
import TitleLayout from 'layout/TitleLayout';
import Loadable from 'components/Loadable';
import ProtectedRoute from 'components/ProtectedRoute';
const DocumentSuitePage = Loadable(lazy(() => import('pages/document-suite')));

const StandaloneAgenda = Loadable(lazy(() => import('pages_i/agenda/StandaloneAgenda')));

export const routerFutureConfig = {
  v7_startTransition: true,
  v7_relativeSplatPath: true
};

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter(
  [
    {
      path: '/document-suite',
      element: (
        <ProtectedRoute>
          <DocumentSuitePage />
        </ProtectedRoute>
      )
    },
    {
      path: '/suite-documental',
      element: (
        <ProtectedRoute>
          <DocumentSuitePage />
        </ProtectedRoute>
      )
    },
    {
      element: <TitleLayout />,
      children: [
        MainRoutes,
        LoginRoutes,
        AreasRoutes,
        AreasIberdrolaRoutes,
        FamiliasRoutes,
        NotificationsRoutes,
        ContabilidadRoutes,
        ProduccionRoutes,
        OperariosRoutes,
        VrpRoutes,
        CuadrosRoutes,
        AdminRoutes,
        {
          path: '/i/agenda',
          element: (
            <ProtectedRoute>
              <StandaloneAgenda />
            </ProtectedRoute>
          )
        },
        IberdrolaRoutes
      ]
    }
  ],
  {
    basename: import.meta.env.VITE_APP_BASE_NAME,
    future: routerFutureConfig
  }
);

export default router;
